<template>
    <Page :is-loading="isPageLoading" :page-code="pageCode" @reload="loadPage">
        <div class="page-body" v-if="orderDetail.goods">
            <Panel>
                <span slot="title">
                    <i class="iconfont icon-doctoral-cap fs20px top2px" /> {{ orderDetail.goods.name }}
                </span>
                <div class="lh2em bottom-line">
                    {{ orderDetail.goods.description }}
                </div>
                <div class="mb-1rem">
                    <GoodsCard :goods="orderDetail.goods" :coinExchange="orderDetail.mideCoinExchange"/>
                    <StudentCard :order="orderDetail" />
                </div>
            </Panel>
            <VanButton round block :disabled="paying" :type="isWxBrowser ? 'primary' : 'info'" @click="handlePayClick">
                确认付款
            </VanButton>
            <Help :link="isWxBrowser ? '/user-doc/微信交费/index.html' : '/user-doc/支付宝交费/index.html'">
                <span v-if="isWxBrowser">
                    <i class="iconfont icon-zhifubao-plane fs17px top2px" /> 支付宝交费请点击这里查看操作方法
                </span>
                <span v-else>
                    <i class="iconfont icon-weixin-plane fs17px top2px" /> 微信交费请点击这里查看操作方法
                </span>
            </Help>
        </div>
    </Page>
</template>

<script>
    import Page from '../../../../components/Page.vue';
    import Panel from '../../../../components/Panel.vue';
    import Help from '../../../../components/Help.vue';
    import StudentCard from '../../components/StudentCard.vue';
    import GoodsCard from '../../components/GoodsCard.vue';
    import PageLoading from '../../../../mixins/PageLoading';
    import WxPreparing from '../../../../mixins/WxPreparing';
    import Utils from '../../../../utils';

    export default {
        name: 'OrderMasterOrder',
        components: {
            Page, Panel, Help, GoodsCard, StudentCard,
        },
        mixins: [PageLoading, WxPreparing],
        data() {
            return {
                orderDetail: {
                },
                paying: false,
                coinNumber: 0,
                coin: 0,
            };
        },
        computed: {
            total() {
                return this.orderDetail.goods ? this.orderDetail.goods.map((g) => g.realPrice).reduce((a, c) => a + c, 0) : 0;
            },
        },
        async mounted() {
            await this.loadPage();
            await this.hideWxAllMenuItems();
        },
        methods: {
            async loadPageData() {
                const { studentUuid, goodsUuid, coin } = this.$route.query;
                this.coin = coin;
                const res = await this.$api.orderMaster.goodsDetails(studentUuid, goodsUuid);

                if (res.data.data.paid) {
                    await this.$router.replace({
                        path: '/coin/master/detail',
                        query: { studentUuid, goodsUuid, coin },
                    });
                    return;
                }
                this.orderDetail = res.data.data;
                this.orderDetail.goods.coin = coin || 0;
                this.orderDetail.student.coin = coin || 0;
            },
            async handlePayClick() {
                const {
                    studentUuid, goodsUuid, coin, classUuid,
                } = this.$route.query;
                this.paying = true;
                const data = {};
                data.mideCoinAmount = this.orderDetail.student.coin;
                data.studentUuid = this.orderDetail.student.uuid;
                data.mideCoinGoodsUuid = this.orderDetail.goods.uuid;
                data.classUuid = classUuid;
                data.payType = 0;
                try {
                    if (this.isWxBrowser) {
                        data.payType = 2;
                        const res = await this.$api.orderMaster.getOrder(data);
                        await Utils.wx.pay(res.data.data);
                    } else {
                        data.payType = 1;
                        const res = await this.$api.orderMaster.getOrder(data);
                        await Utils.alipay.pay(res.data.data);
                    }

                    this.$toast.success('支付成功');
                    await Utils.delay(2000);
                    await this.$router.replace({
                        path: '/coin/master/detail',
                        query: { studentUuid, goodsUuid, coin },
                    });
                } catch (err) {
                    this.$toast.fail('支付已取消');
                } finally {
                    this.paying = false;
                }
            },
        },
    };
</script>

<style scoped lang="less">
    .icon-zhifubao-plane {
        color: #00AFF0;
    }
    .icon-weixin-plane {
        color: #07C160;
    }
</style>
